import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-publish',
  templateUrl: './event-publish.component.html',
  styleUrls: ['./event-publish.component.css'],
})
export class EventPublishComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
